import React from 'react'
import { ReportsContext, useReportsImplementation } from './ReportsContext'

export const ReportsProvider: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const reportsValue = useReportsImplementation()
  return <ReportsContext.Provider value={reportsValue}>{children}</ReportsContext.Provider>
}

export function useReports() {
  const context = React.useContext(ReportsContext)
  if (!context) {
    throw new Error('useReports must be used within a ReportsProvider')
  }
  return context
}
